import { render } from "./AppMain.vue?vue&type=template&id=7b34ac56&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=7b34ac56&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=7b34ac56&lang=scss"
import "./AppMain.vue?vue&type=style&index=2&id=7b34ac56&scoped=true&lang=css"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b34ac56"]])

export default __exports__